import React, { useState, useEffect } from 'react';
import KycContainer from '../KYCContainer/KYC';
import PAN from '../../../components/PANUpload/PAN';
import { UserKycStatus } from '../../../common/userData/UserKycStatus';

export default function NewPanContainer() {
  let data =  {  pan: '',
    address: '',
    selfie: '',
    bank: '',
    custom: '',
    ref: ''
  }
  const [Loading, setLoading] = useState(false);

  const [kycStatus, setKycStatus] = useState(data);

  !Loading? UserKycStatus().then(res=> {
    setKycStatus(res), setLoading(true)
  }
    ).catch(e =>{console.log(e)}):
    null

  const current_page = {
    pan: true,
    address: false, 
    selfie: false,
    bank: false,
    ref: false
  };
  const onclick_handler = id => {
    if (id == 'pan') {
      document.getElementById('upload_front').style.display = 'block';
      let c = document.getElementsByClassName('tooltip');
      for (let i = 0; i < c.length; i++) {
        c[i].style.opacity = '0.2';
      }
      let a = document.getElementById('doc_container');
      a.style.backgroundColor = 'black';
      a.style.height = '100%';
      a.style.position = 'absolute';
      a.style.opacity = '0.3';
      a.style.pointerEvents = 'none';
    }
  };

  return (
    <div>
      <KycContainer
        guideName="PAN Card"
        data={kycStatus}
        container={PAN}
        curr_page={current_page}
        onclick_handler={onclick_handler}
        // OnSubmit={this.OnSubmit}
        // componentHandler={this.props.componentHandler}
      />
    </div>
  );
}
